/**
 * VisibilityReconnectProvider
 *
 * Context provider that exposes reconnect state and wakeCounter
 * from the useVisibilityReconnect hook to the component tree.
 */

import { createContext, useContext, type ReactNode } from 'react';
import { useVisibilityReconnectCore, type ReconnectState } from '@/hooks/useVisibilityReconnect';

interface VisibilityReconnectContextValue {
  reconnectState: ReconnectState;
  wakeCounter: number;
}

const VisibilityReconnectContext = createContext<VisibilityReconnectContextValue | null>(null);

export function VisibilityReconnectProvider({ children }: { children: ReactNode }) {
  const value = useVisibilityReconnectCore();
  return (
    <VisibilityReconnectContext.Provider value={value}>
      {children}
    </VisibilityReconnectContext.Provider>
  );
}

export function useVisibilityReconnect(): VisibilityReconnectContextValue {
  const ctx = useContext(VisibilityReconnectContext);
  if (!ctx) {
    // Return safe defaults if used outside provider (e.g. auth pages)
    return { reconnectState: 'idle', wakeCounter: 0 };
  }
  return ctx;
}
